"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var InputTextarea_styles_1 = __importDefault(require("./InputTextarea.styles"));
var FormErrorMessage_1 = __importDefault(require("../FormErrorMessage/FormErrorMessage"));
var InputTextarea = function (_a) {
    var label = _a.label, labelDescription = _a.labelDescription, maxLength = _a.maxLength, id = _a.id, value = _a.value, error = _a.error, valueChanged = _a.valueChanged;
    return (react_1.default.createElement(InputTextarea_styles_1.default, null,
        react_1.default.createElement("label", null,
            label,
            labelDescription && react_1.default.createElement("span", null,
                "\u00A0",
                labelDescription)),
        react_1.default.createElement("textarea", { id: id, name: id, defaultValue: value, maxLength: maxLength, onInput: function (e) {
                if (valueChanged)
                    valueChanged(id, e.currentTarget.value);
            } }),
        react_1.default.createElement(FormErrorMessage_1.default, null, error)));
};
exports.default = InputTextarea;
